module.exports = __webpack_public_path__ + "static/media/upsellingScreenPage.c2866bc0.png";